var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _g, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoryboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    width: 800,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ebebeb } \n\t\t.s1 { fill: #8da495 } \n\t\t.s2 { fill: #b0b8b2 } \n\t\t.s3 { fill: #9db7a4 } \n\t\t.s4 { fill: #e0e0e0 } \n\t\t.s5 { opacity: .7;fill: #71997f } \n\t\t.s6 { fill: #728a7a } \n\t\t.s7 { fill: #6a8573 } \n\t\t.s8 { fill: #627b6b } \n\t\t.s9 { fill: #aaaeab } \n\t\t.s10 { fill: #5c7b67 } \n\t\t.s11 { fill: #445e4d } \n\t\t.s12 { fill: #b2ccbb } \n\t\t.s13 { fill: #e3e9e5 } \n\t\t.s14 { fill: #71997f } \n\t\t.s15 { fill: #7a9382 } \n\t\t.s16 { opacity: .5;fill: #8bab96 } \n\t\t.s17 { fill: #253d34 } \n\t\t.s18 { fill: #000000 } \n\t\t.s19 { fill: #61876e } \n\t\t.s20 { opacity: .2;fill: #315c4c } \n\t\t.s21 { opacity: .8;fill: #bbcbc0 } \n\t\t.s22 { fill: #263238 } \n\t\t.s23 { opacity: .7;fill: #ffffff } \n\t\t.s24 { opacity: .3;fill: #ffffff } \n\t\t.s25 { fill: #ffffff } \n\t\t.s26 { fill: #b55b52 } \n\t\t.s27 { fill: #a02724 } \n\t\t.s28 { opacity: .8;fill: #d1dcd4 } \n\t\t.s29 { opacity: .1;fill: #000000 } \n\t\t.s30 { fill: #e3ba96 } \n\t\t.s31 { opacity: .2;fill: #000000 } \n\t\t.s32 { fill: #ed893e } \n\t\t.s33 { fill: #2e353a } \n\t\t.s34 { fill: #de5753 } \n\t\t.s35 { opacity: .8;fill: #ffffff } \n\t\t.s36 { opacity: .5;fill: #263238 } \n\t\t.s37 { opacity: .6;fill: #263238 } \n\t\t.s38 { opacity: .4;fill: #000000 } \n\t\t.s39 { opacity: .5;fill: #000000 } \n\t\t.s40 { opacity: .3;fill: #000000 } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "story"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m666.8 654.6h53v0.4h-53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m516 658.9h14v0.4h-14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m634.5 639.7h30.7v0.4h-30.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m83.9 642.4h69.1v0.4h-69.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m167.3 642.4h10.1v0.4h-10.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m210.4 649.2h149.8v0.4h-149.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m381.4 557.5h-308.9c-1.2 0-2.4-0.3-3.5-0.7-1.1-0.5-2.1-1.1-3-2-0.8-0.8-1.5-1.9-2-3-0.4-1.1-0.7-2.3-0.7-3.5v-434.2c0.1-1.2 0.3-2.4 0.8-3.5 0.4-1.1 1.1-2.1 1.9-3 0.9-0.8 1.9-1.5 3-1.9 1.1-0.5 2.3-0.7 3.5-0.7h308.9c1.2 0 2.4 0.2 3.5 0.7 1.1 0.5 2.2 1.1 3 2 0.8 0.8 1.5 1.8 2 2.9 0.4 1.1 0.7 2.3 0.7 3.5v434.2c0 1.2-0.3 2.4-0.7 3.5-0.5 1.1-1.2 2.2-2 3-0.8 0.9-1.9 1.5-3 2-1.1 0.4-2.3 0.7-3.5 0.7zm-308.9-452.2c-1.2 0-2.3 0.2-3.4 0.7-1 0.4-2 1.1-2.8 1.9-0.8 0.8-1.4 1.8-1.9 2.8-0.4 1.1-0.7 2.2-0.7 3.4v434.2c0 1.2 0.3 2.3 0.7 3.4 0.5 1 1.1 2 1.9 2.8 0.8 0.8 1.8 1.5 2.8 1.9 1.1 0.5 2.2 0.7 3.4 0.7h308.9c1.2 0 2.3-0.2 3.4-0.7 1-0.4 2-1.1 2.8-1.9 0.8-0.8 1.5-1.8 1.9-2.8 0.4-1.1 0.7-2.2 0.7-3.4v-434.2c0-1.2-0.3-2.3-0.7-3.4-0.4-1-1.1-2-1.9-2.8-0.8-0.8-1.8-1.5-2.8-1.9-1.1-0.5-2.2-0.7-3.4-0.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m727.5 557.5h-308.9c-1.2 0-2.4-0.3-3.5-0.7-1.1-0.5-2.2-1.1-3-2-0.8-0.8-1.5-1.9-2-3-0.4-1.1-0.7-2.3-0.7-3.5v-434.2c0-1.2 0.3-2.4 0.7-3.5 0.5-1.1 1.2-2.1 2-3 0.9-0.8 1.9-1.5 3-1.9 1.1-0.5 2.3-0.7 3.5-0.7h308.9c1.2 0 2.4 0.2 3.5 0.7 1.1 0.5 2.1 1.1 3 2 0.8 0.8 1.5 1.8 2 2.9 0.4 1.1 0.7 2.3 0.7 3.5v434.2c0 1.2-0.3 2.4-0.7 3.5-0.5 1.1-1.2 2.2-2 3-0.9 0.9-1.9 1.5-3 2-1.1 0.4-2.3 0.7-3.5 0.7zm-308.9-452.2c-1.2 0-2.3 0.2-3.4 0.7-1 0.4-2 1.1-2.8 1.9-0.8 0.8-1.5 1.8-1.9 2.8-0.4 1.1-0.7 2.2-0.7 3.4v434.2c0 1.2 0.3 2.3 0.7 3.4 0.4 1 1.1 2 1.9 2.8 0.8 0.8 1.8 1.5 2.8 1.9 1.1 0.5 2.2 0.7 3.4 0.7h308.9c1.2 0 2.3-0.2 3.4-0.7 1-0.4 2-1.1 2.8-1.9 0.8-0.8 1.4-1.8 1.9-2.8 0.4-1.1 0.7-2.2 0.7-3.4v-434.2c0-1.2-0.3-2.3-0.7-3.4-0.5-1-1.1-2-1.9-2.8-0.8-0.8-1.8-1.5-2.8-1.9-1.1-0.5-2.2-0.7-3.4-0.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0 628.8h800v0.4h-800z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m553.6 534.7h95.7v95.7h-95.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m494.8 534.7h58.8v95.7h-58.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m530 534.7v36.2l-1.5-1.3-2.7 1.6-2.3-1.6-3 1.6-3.2-1.6-2.1 1.6-2.3-1.2v-35.3h17.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m530 534.7v36.2l-1.5-1.3-2.7 1.6-2.3-1.6-3 1.6-3.2-1.6-2.1 1.6-2.3-1.2v-35.3h17.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m464.2 573.4h57v57h-57z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m429.1 573.4h35v57h-35z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m475.1 589.5l-10.9-16.1h57l10.8 16.1h-56.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m454.8 589.5h-35l10.3-16.1h35.1l-10.4 16.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m650.6 573.4h57v57h-57z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m615.6 573.4h35v57h-35z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m661.5 559.1h57l-10.9 14.3h-57l10.9-14.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m640.3 559.1l10.3 14.3h-35l-10.3-14.3h35z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m184.5 627.6l-41.6-41.6-41.6 41.6q-0.4 0.5-1 0.7-0.6 0.3-1.3 0.3-0.6 0-1.2-0.3-0.6-0.2-1-0.7-0.5-0.4-0.7-1-0.3-0.6-0.3-1.2 0-0.7 0.3-1.2 0.2-0.6 0.7-1.1l46.2-46.2 46.2 46.2q0.4 0.5 0.7 1.1 0.2 0.5 0.2 1.2 0 0.6-0.2 1.2-0.3 0.6-0.7 1-0.5 0.5-1.1 0.8-0.6 0.3-1.3 0.3-0.6 0-1.2-0.3-0.6-0.3-1.1-0.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m142.8 630.4q-0.6 0-1.2-0.2-0.6-0.2-1-0.7-0.5-0.4-0.7-1-0.3-0.6-0.3-1.3v-357h6.4v357q0 0.7-0.2 1.3-0.3 0.6-0.7 1-0.5 0.5-1 0.7-0.6 0.2-1.3 0.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m118.7 270.3c-8.5-3.5-9.7-20-2.7-37 7.1-16.9 19.6-27.8 28.1-24.3l52.9 22c8.5 3.5 9.6 20 2.6 37-7 16.9-19.6 27.8-28 24.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m197 231c8.5 3.5 9.6 20 2.6 37-7 16.9-19.6 27.8-28 24.3-8.5-3.5-9.7-20.1-2.7-37 7.1-16.9 19.6-27.9 28.1-24.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m195.4 234.8c7.4 3.1 8.4 17.5 2.3 32.4-6.1 14.9-17.1 24.3-24.5 21.3-7.4-3.1-8.5-17.6-2.3-32.4 6.1-14.8 17.1-24.3 24.5-21.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m193.6 265.5c-4.3 10.3-11.9 16.9-17.1 14.8-5.1-2.1-5.8-12.2-1.6-22.5 4.3-10.3 11.9-17 17.1-14.8 5.1 2.1 5.9 12.2 1.6 22.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m159.9 263.3l0.9 13.1 2.2-1.9 0.7 10.5-2.2 2 1 13.1-17.7 28-2-28 17.1-36.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m208.7 259.9l-0.9-13.1-2.2 1.9-0.8-10.5 2.2-1.9-0.9-13.1 44.8-16.8 2 28-44.2 25.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m172.5 304.2l10-8.6-0.2-2.9 7.9-6.9 0.2 2.9 10-8.6 13.1 49.3-21.2 18.4-19.8-43.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m196 219.1l-9.9 8.6 0.2 2.9-8 6.9-0.2-2.9-9.9 8.6 14-38.1 21.2-18.4-7.4 32.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m328.2 196.8c0-0.7 0.6-1.3 1.3-1.3h33.7c0.8 0 1.3 0.6 1.3 1.3v7.2c0 0.7-0.5 1.3-1.3 1.3h-33.7c-0.7 0-1.3-0.6-1.3-1.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m290.1 196.8c0-0.7 0.6-1.3 1.3-1.3h33.7c0.7 0 1.3 0.6 1.3 1.3v7.2c0 0.7-0.6 1.3-1.3 1.3h-33.7c-0.7 0-1.3-0.6-1.3-1.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m307.1 184.8c0-0.8 0.5-1.4 1.3-1.4h33.7c0.7 0 1.3 0.6 1.3 1.4v7.1c0 0.7-0.6 1.3-1.3 1.3h-33.7c-0.8 0-1.3-0.6-1.3-1.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m269 184.8c0-0.8 0.6-1.4 1.3-1.4h33.7c0.8 0 1.4 0.6 1.4 1.4v7.1c0 0.7-0.6 1.3-1.4 1.3h-33.7c-0.7 0-1.3-0.6-1.3-1.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m548.5 190.8c0-0.7 0.6-1.3 1.3-1.3h33.8c0.7 0 1.3 0.6 1.3 1.3v7.1c0 0.7-0.6 1.3-1.3 1.3h-33.8c-0.7 0-1.3-0.6-1.3-1.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m565.5 178.7c0-0.7 0.6-1.3 1.3-1.3h33.8c0.7 0 1.3 0.6 1.3 1.3v7.1c0 0.8-0.6 1.4-1.3 1.4h-33.8c-0.7 0-1.3-0.6-1.3-1.4z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m527.5 178.7c0-0.7 0.6-1.3 1.3-1.3h33.7c0.7 0 1.3 0.6 1.3 1.3v7.1c0 0.8-0.6 1.4-1.3 1.4h-33.7c-0.7 0-1.3-0.6-1.3-1.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m633.8 479c0-0.7 0.6-1.3 1.3-1.3h33.7c0.7 0 1.3 0.6 1.3 1.3v7.1c0 0.7-0.6 1.3-1.3 1.3h-33.7c-0.7 0-1.3-0.6-1.3-1.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m650.7 466.9c0-0.7 0.6-1.3 1.4-1.3h33.7c0.7 0 1.3 0.6 1.3 1.3v7.1c0 0.8-0.6 1.4-1.3 1.4h-33.7c-0.8 0-1.4-0.6-1.4-1.4z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m612.7 466.9c0-0.7 0.6-1.3 1.3-1.3h33.7c0.7 0 1.3 0.6 1.3 1.3v7.1c0 0.8-0.6 1.4-1.3 1.4h-33.7c-0.7 0-1.3-0.6-1.3-1.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m152.1 436.1c0-0.7 0.6-1.3 1.3-1.3h33.7c0.7 0 1.3 0.6 1.3 1.3v7.1c0 0.8-0.6 1.4-1.3 1.4h-33.7c-0.7 0-1.3-0.6-1.3-1.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m169 424c0-0.7 0.6-1.3 1.4-1.3h33.7c0.7 0 1.3 0.6 1.3 1.3v7.1c0 0.8-0.6 1.4-1.3 1.4h-33.7c-0.8 0-1.4-0.6-1.4-1.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m387.7 561.9q0.8-5.6 2.3-11.2 1.6-5.5 3.8-10.8 2.2-5.3 5.1-10.3 2.8-5 6.3-9.6c-7.4 2.8-18.2 3.4-11.7-7.7 7.8-13.5 6.8-1.6 12.9-5.2 5-3 1.3-11.1 8.1-15.1 7.9-4.5 5.2 10.8 11.3 6.9 4.3-2.7 11.7-5 14.4 1.2-3.2 4.2-7.3 8.1-12.3 9.7-7.2 2.3 6.5 7.3 2 11.1-4.4 3.8-11.1 6.8-10.7 1.7 0.4-5-6.2 1.9-3.8 5.4 2.3 3.5-8.6 10.7-8.6 4.7 0-6-0.2-12-0.2-12q-3.5 4.9-6.2 10.1-2.8 5.3-4.9 11-2 5.6-3.3 11.4-1.3 5.9-1.8 11.8c-1.1-1.2-1.6-1.8-2.7-3.1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m375.5 567q-1.5-5.8-3.8-11.3-2.4-5.6-5.4-10.7-3-5.2-6.7-9.9-3.7-4.7-8-8.9c0 0 0.9 6.1 2 11.9 1 5.8-10.9 0.7-9.3-3.2 1.6-3.9-6.1-9.4-4.8-4.6 1.3 4.9-5.7 3.2-10.8 0.3-5.1-3 7.4-10.4 0-11.3-5.3-0.7-10-3.8-13.9-7.4 1.6-6.6 9.3-5.6 14-3.7 6.7 2.7 1.4-11.9 9.9-8.8 7.5 2.7 5.2 11.2 10.7 13.3 6.6 2.6 3.5-9 13.6 2.8 8.3 9.8-2.4 11.1-10.1 9.6q4.2 3.9 7.9 8.3 3.7 4.4 6.8 9.2 3.2 4.9 5.7 10.1 2.5 5.1 4.3 10.6c-0.9 1.4-1.3 2.1-2.1 3.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m376.8 564.9q2.1-7.3 3.1-14.8 1-7.5 1-15.1 0.1-7.5-0.9-15-1-7.6-3-14.9c0 0-2.9 7.1-5.5 14.2-2.7 7.2-12.4-6.3-8-9.3 4.3-3.1-0.6-14.1-2.3-8-1.7 6-8.4-0.2-12-6.8-3.6-6.5 14.9-6.4 7.3-12.2-5.2-4.2-8.4-10.6-10.3-17 6-6.2 13.7-0.2 17.6 4.9 5.7 7.3 9.2-12 16.5-3.2 6.3 7.7-1.6 15.6 3 21.4 5.7 7.1 9.8-7.5 13.1 11.9 2.8 16-9.7 10.5-17.3 4q2.1 7 3.3 14.2 1.3 7.2 1.6 14.4 0.3 7.3-0.3 14.6-0.7 7.3-2.2 14.4c-1.8 1-2.7 1.5-4.7 2.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m399 630.4h-36.9q-0.9 0-1.8-0.3-0.8-0.4-1.5-1-0.7-0.7-1-1.5-0.4-0.8-0.5-1.8l-3.9-63.6c-0.2-2.8 54.6-2.8 54.4 0l-3.9 63.6q-0.1 1-0.5 1.8-0.4 0.9-1 1.5-0.7 0.6-1.6 1-0.9 0.3-1.8 0.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-2",
    className: "s16",
    d: "m392.3 694.9c-171.6 0-310.2-8.1-310.2-18.1 0-10 138.6-18.1 310.2-18.1 171.5 0 310.2 8.1 310.2 18.1 0 10-138.7 18.1-310.2 18.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-2"
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m577.2 674.9h-6.1l-73.7-330.8-1.8 330.8h-5.8l-1.8-330.8-73.7 330.8h-6.1l84.5-396.8 84.5 396.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.7
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m461.1 465h-8.2l13.4-62.7h8.8l-14 62.7z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m497.1 402.3l-0.3 62.7h-8.1l-0.3-62.7h8.7z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m519.2 402.3l13.3 62.7h-8.2l-13.9-62.7h8.8z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m339.4 250.1c0-4.3 3.5-7.8 7.8-7.8h291c4.4 0 7.8 3.5 7.8 7.8v193.3c0 4.4-3.4 7.9-7.8 7.9h-291c-4.3 0-7.8-3.5-7.8-7.9z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s17",
    d: "m630.8 454.2h-276.1c-2.4 0-4.8-0.5-7-1.4-2.2-0.9-4.2-2.2-5.9-3.9-1.7-1.7-3-3.7-4-5.9-0.9-2.3-1.3-4.6-1.4-7v-178.4c0.1-2.4 0.5-4.7 1.4-7 1-2.2 2.3-4.2 4-5.9 1.7-1.7 3.7-3 5.9-3.9 2.2-0.9 4.6-1.4 7-1.4h276.1c2.4 0 4.7 0.5 6.9 1.4 2.2 0.9 4.3 2.2 5.9 3.9 1.7 1.7 3.1 3.7 4 5.9 0.9 2.2 1.4 4.6 1.4 7v178.4c0 2.4-0.5 4.8-1.4 7-0.9 2.2-2.3 4.2-4 5.9-1.6 1.7-3.7 3-5.9 3.9-2.2 0.9-4.5 1.4-6.9 1.4zm-276.1-208.9c-1.7 0-3.3 0.3-4.8 0.9-1.5 0.6-2.8 1.5-4 2.7-1.1 1.1-2 2.5-2.6 4-0.7 1.5-1 3.1-1 4.7v178.4c0 1.6 0.3 3.2 1 4.7 0.6 1.5 1.5 2.9 2.6 4 1.2 1.2 2.5 2.1 4 2.7 1.5 0.6 3.1 0.9 4.8 0.9h276.1c1.6 0 3.2-0.3 4.7-0.9 1.5-0.6 2.8-1.5 4-2.7 1.1-1.1 2.1-2.5 2.7-4 0.6-1.5 0.9-3.1 0.9-4.7v-178.4c0-1.6-0.3-3.2-0.9-4.7-0.6-1.5-1.6-2.9-2.7-4-1.2-1.2-2.5-2.1-4-2.7-1.5-0.6-3.1-0.9-4.7-0.9z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m642.9 255.2q-0.2-1.2-0.7-2.4-0.5-1.1-1.2-2.1-0.7-1-1.6-1.9l4.9-3.3q1.1 1.2 2 2.6 0.9 1.5 1.5 3 0.6 1.6 0.9 3.2 0.3 1.6 0.3 3.3v178.4c0 2.4-0.5 4.8-1.4 7-0.9 2.2-2.3 4.2-4 5.9-1.6 1.7-3.7 3-5.9 3.9-2.2 0.9-4.5 1.4-6.9 1.4h-276.1q-1.5 0-3-0.2-1.5-0.3-2.9-0.8-1.4-0.5-2.8-1.2-1.3-0.7-2.5-1.6l5.3-3.6q0.6 0.4 1.4 0.7 0.7 0.3 1.4 0.4 0.8 0.2 1.5 0.3 0.8 0.1 1.6 0.1h276.1c1.7 0 3.3-0.3 4.8-0.9 1.5-0.6 2.8-1.5 4-2.7 1.1-1.1 2-2.5 2.7-4 0.6-1.5 0.9-3.1 0.9-4.7v-178.4q0-1.2-0.3-2.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Storyboard--inject-2"
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m356.9 264.4h87.3v73.6h-87.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m356.9 264.4h87.3v73.6h-87.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m360.6 267.5h79.9v45.2h-79.9z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m360.6 267.5h79.9v45.2h-79.9z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m360.6 267.5h11.9v12h-11.9z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m419.5 319.3q-0.3-0.2-0.3-0.6 0-0.4 0.3-0.6 0.2-0.3 0.6-0.3h12.8q0.3 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.3 0.3-0.6 0.3h-12.8q-0.4 0-0.6-0.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m391.9 319.3q-0.3-0.2-0.3-0.6 0-0.4 0.3-0.6 0.2-0.3 0.6-0.3h22.8q0.4 0 0.7 0.3 0.2 0.2 0.2 0.6 0 0.4-0.2 0.6-0.3 0.3-0.7 0.3h-22.8q-0.4 0-0.6-0.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m367.7 319.3q-0.3-0.2-0.3-0.6 0-0.4 0.3-0.6 0.2-0.3 0.6-0.3h18.9q0.4 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-18.9q-0.4 0-0.6-0.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m412 325.7q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h13.4q0.3 0 0.6 0.2 0.2 0.3 0.2 0.7 0 0.3-0.2 0.6-0.3 0.2-0.6 0.2h-13.4q-0.4 0-0.6-0.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m387.3 325.7q-0.2-0.3-0.2-0.6 0-0.4 0.2-0.7 0.3-0.2 0.6-0.2h19.1q0.3 0 0.6 0.2 0.2 0.3 0.2 0.7 0 0.3-0.2 0.6-0.3 0.2-0.6 0.2h-19.1q-0.3 0-0.6-0.2z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m374.5 325.7q-0.2-0.3-0.2-0.6 0-0.4 0.2-0.7 0.3-0.2 0.6-0.2h8q0.3 0 0.6 0.2 0.2 0.3 0.2 0.7 0 0.3-0.2 0.6-0.3 0.2-0.6 0.2h-8q-0.3 0-0.6-0.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m418 332q-0.3-0.2-0.3-0.6 0-0.3 0.3-0.6 0.2-0.3 0.6-0.3h10.3q0.4 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-10.3q-0.4 0-0.6-0.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m396 332q-0.2-0.2-0.2-0.6 0-0.3 0.2-0.6 0.3-0.3 0.6-0.3h17.1q0.4 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-17.1q-0.3 0-0.6-0.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m371.6 332q-0.3-0.2-0.3-0.6 0-0.3 0.3-0.6 0.2-0.3 0.6-0.3h18.7q0.3 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.3 0.3-0.6 0.3h-18.7q-0.4 0-0.6-0.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m407.7 261.2c1.3-0.1 2.6 0.4 3.5 1.3 1 0.8 1.5 2.1 1.5 3.4 0 1.3-0.5 2.5-1.5 3.4-0.9 0.9-2.2 1.3-3.5 1.3h-2.9c-1.3 0-2.6-0.4-3.5-1.3-0.9-0.9-1.5-2.1-1.5-3.4 0-1.3 0.6-2.6 1.5-3.4 0.9-0.9 2.2-1.4 3.5-1.3h3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m412.5 265.9c0 1.9-1.2 3.6-2.9 4.3-1.8 0.8-3.8 0.4-5.1-1-1.4-1.3-1.8-3.4-1.1-5.1 0.8-1.8 2.5-2.9 4.4-2.9q0.9 0 1.8 0.3 0.9 0.4 1.5 1.1 0.7 0.6 1 1.5 0.4 0.8 0.4 1.8z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s22",
    d: "m396.4 279.8v33.2h-9.6v-28.7zm-6.2 22.6h-1.8v1.8h1.8zm0-9.8h-1.8v1.8h1.8zm0-6.5h-1.8v1.8h1.8zm3.9 22.8h-1.8v1.8h1.8zm0-9.8h-1.8v1.8h1.8zm0-3.2h-1.8v1.8h1.8zm0-6.5h-1.8v1.8h1.8z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s22",
    d: "m415.4 292.6v20.4h-6.8v-23.6zm-2.5 14h1.3v-1.3h-1.3zm0-6.9h1.3v-1.3h-1.3zm0-4.6h1.3v-1.3h-1.3zm-2.7 16.2h1.3v-1.2h-1.3zm0-7h1.3v-1.3h-1.3zm0-2.3h1.3v-1.2h-1.3zm0-4.7h1.3v-1.2h-1.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s22",
    d: "m407.2 287.5v25.4h-9.4v-25.4h1v-4.4h1v-4.8h0.9v-2.1l1.8-2.7 1.7 2.7v2.1h0.9v4.8h1.1v4.4zm-6.9 15.7h-1.3v1.3h1.3zm0-4.8h-1.3v1.3h1.3zm0-4.8h-1.3v1.3h1.3zm2.8 11.9h-1.3v1.3h1.3zm0-7.1h-1.4v1.3h1.3zm0-2.4h-1.4v1.3h1.4zm0-7.1h-1.4v1.3h1.3zm2.7 16.7h-1.3v1.3h1.3zm0-4.8h-1.3v1.3h1.3zm0-7.2h-1.3v1.3h1.3zm0-4.8h-1.3v1.4h1.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s22",
    d: "m385.2 292.2v20.8h-7.8v-20.8zm-5.6 12.8h-1.1v1.1h1.1zm0-3.9h-1.1v1.1h1.1zm0-3.9h-1.1v1h1.1zm2.3 9.8h-1v1h1zm0-5.8h-1.1v1.1h1zm0-2h-1.1v1.1h1.1zm0-5.9h-1.1v1.1h1zm2.2 13.7h-1v1h1zm0-3.9h-1v1.1h1zm0-5.8h-1v1h1zm0-3.9h-1v1.1h1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s22",
    d: "m424.5 292.2v20.8h-7.7v-20.8zm-5.7 12.8h-1.1v1.1h1.1zm0-3.9h-1.1v1.1h1.1zm0-3.9h-1.1v1h1.1zm2.3 9.8h-1.1v1h1.1zm0-5.8h-1.1v1.1h1.1zm0-2h-1.1v1.1h1.1zm0-5.9h-1.1v1.1h1.1zm2.3 13.7h-1v1h1zm0-3.9h-1.1v1.1h1zm0-5.8h-1v1h1zm0-3.9h-1.1v1.1h1.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m367.7 270v7h-1.6v-5.7h-1.4v-1.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m451.9 264.4h87.4v73.6h-87.4z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m451.9 264.4h87.4v73.6h-87.4z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m455.6 267.5h80v45.2h-80z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m455.6 267.5h80v45.2h-80z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m455.6 267.5h12v12h-12z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m514.6 319.3q-0.3-0.2-0.3-0.6 0-0.4 0.3-0.6 0.2-0.3 0.6-0.3h12.8q0.4 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-12.8q-0.4 0-0.6-0.3z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m486.9 319.3q-0.2-0.2-0.2-0.6 0-0.4 0.2-0.6 0.3-0.3 0.7-0.3h22.8q0.4 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-22.8q-0.4 0-0.7-0.3z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m462.7 319.3q-0.2-0.2-0.3-0.6 0.1-0.4 0.3-0.6 0.3-0.3 0.6-0.3h18.9q0.3 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.3 0.3-0.6 0.3h-18.9q-0.3 0-0.6-0.3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m507 325.7q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.3-0.2 0.6-0.2h13.4q0.4 0 0.6 0.2 0.3 0.3 0.3 0.7 0 0.3-0.3 0.6-0.2 0.2-0.6 0.2h-13.4q-0.3 0-0.6-0.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m482.4 325.7q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h19q0.4 0 0.6 0.2 0.3 0.3 0.3 0.7 0 0.3-0.3 0.6-0.2 0.2-0.6 0.2h-19q-0.4 0-0.6-0.2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m469.6 325.7q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h7.9q0.4 0 0.6 0.2 0.3 0.3 0.3 0.7 0 0.3-0.3 0.6-0.2 0.2-0.6 0.2h-7.9q-0.4 0-0.6-0.2z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m513 332q-0.3-0.2-0.3-0.6 0-0.3 0.3-0.6 0.2-0.3 0.6-0.3h10.3q0.4 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-10.3q-0.4 0-0.6-0.3z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m491.1 332q-0.3-0.2-0.3-0.6 0-0.3 0.3-0.6 0.2-0.3 0.6-0.3h17.1q0.4 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-17.1q-0.4 0-0.6-0.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m466.6 332q-0.3-0.2-0.3-0.6 0-0.3 0.3-0.6 0.2-0.3 0.6-0.3h18.7q0.4 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-18.7q-0.4 0-0.6-0.3z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m506.3 262.5c1 0.8 1.5 2.1 1.5 3.4 0 1.3-0.5 2.5-1.5 3.4-0.9 0.9-2.2 1.3-3.5 1.3h-2.9c-1.3 0-2.6-0.4-3.5-1.3-0.9-0.9-1.5-2.1-1.5-3.4 0-1.3 0.6-2.6 1.5-3.4 0.9-0.9 2.2-1.4 3.5-1.3h2.9c1.3-0.1 2.6 0.4 3.5 1.3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m507.5 265.9c0 1.9-1.1 3.6-2.9 4.3-1.7 0.8-3.7 0.4-5.1-1-1.3-1.3-1.7-3.4-1-5.1 0.7-1.8 2.4-2.9 4.3-2.9q1 0 1.8 0.3 0.9 0.4 1.6 1.1 0.6 0.6 1 1.5 0.3 0.8 0.3 1.8z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m483.4 295.5l3.7 2.2v3.2l-4.6-1.2 0.9-4.2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m495.2 279.7c1.8 1.6 4 8.3 1.2 11.1-4-4.7-4.5-11.8-1.2-11.1z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m481 286.7q0-0.5 0.1-0.9 0-0.5 0.1-0.9 0.1-0.5 0.3-0.9 0.5-1.5 1.5-2.8 1-1.2 2.5-1.9 1.4-0.7 3-0.9 1.6-0.1 3.1 0.4c5.9 1.9 7.2 10.5 6.3 15.8-1.1 6-8.1 9.2-12.8 5-3.1-2.8-3.3-6.2-4-12q-0.1-0.5-0.1-0.9z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m480.6 281.6c0 0-1.5-3.6 3.5-4.7 5-1 13.6 0.9 12.9 3.2-0.6 2.3-2.7 2.3-8.2 0.7-0.9 1.6-4.3 2.1-5.5 1.6 1.7 3.8 0.7 10.4-2 10.2-9.1-8.2-0.7-11-0.7-11z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m480.2 289.2c1.6-0.4 3.2 1.5 3.9 3.2 0.7 1.7 0.1 3.4-1.6 3q-0.5-0.1-1-0.3-0.4-0.3-0.8-0.6-0.5-0.3-0.8-0.7-0.4-0.3-0.6-0.8c-0.9-1.5-0.7-3.3 0.9-3.8z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m489.4 287.7c0.3-0.1 0.5 0.3 0.6 0.8 0 0.5-0.2 0.8-0.5 0.9-0.3 0-0.7-0.4-0.7-0.8 0-0.5 0.3-0.9 0.6-0.9z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m495.8 287.1c0.3 0 0.6 0.4 0.6 0.8 0 0.5-0.2 0.9-0.5 0.9-0.3 0.1-0.6-0.3-0.6-0.8-0.1-0.4 0.2-0.9 0.5-0.9z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m494.2 288.5q0.3 0.5 0.6 1.1 0.3 0.5 0.6 1 0.3 0.4 0.6 0.9 0.4 0.5 0.8 0.9-0.2 0.2-0.5 0.3-0.3 0.2-0.6 0.2-0.3 0.1-0.6 0.1-0.3 0.1-0.6 0z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m491.3 284.8q0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.1-0.1 0.1-0.1 0.1-0.1 0-0.1 0.1-0.3 0-0.7 0.1-0.3 0-0.6-0.1-0.4-0.1-0.7-0.2-0.3-0.2-0.5-0.4 0 0-0.1-0.1 0 0 0-0.1 0 0 0-0.1 0.1 0 0.1-0.1 0 0 0.1 0 0-0.1 0.1-0.1 0 0 0.1 0.1 0 0 0.1 0 0.2 0.2 0.4 0.3 0.3 0.1 0.5 0.2 0.3 0 0.6 0 0.2 0 0.5-0.1 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0.1 0.1 0.1 0.1z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m497 285.2q0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0-0.2-0.2-0.4-0.3-0.3-0.1-0.5-0.2-0.3 0-0.6 0-0.2 0-0.5 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0.1-0.1 0 0 0.1 0 0.3-0.1 0.6-0.1 0.4 0 0.7 0.1 0.3 0.1 0.6 0.2 0.3 0.2 0.6 0.4 0 0 0 0.1 0 0 0 0.1 0 0 0 0.1 0 0 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m489.9 294.9q0.5-0.3 1.1-0.5 0.6-0.2 1.2-0.3 0.6-0.1 1.3 0 0.6 0.1 1.2 0.3 0 0.1 0 0.1 0.1 0 0.1 0 0 0.1 0 0.1 0 0 0 0.1-0.1 0-0.1 0 0 0.1 0 0.1-0.1 0-0.1 0-0.1 0-0.1 0-0.5-0.2-1.1-0.3-0.6-0.1-1.2 0-0.6 0-1.1 0.2-0.6 0.2-1.1 0.5 0 0.1 0 0.1 0 0-0.1 0 0 0 0 0-0.1 0-0.1-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m472.2 312.6c0 0-0.3-12.5 11.7-12.5 12 0 20.1 12.5 20.1 12.5z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m481.6 300.6c0 0-1-3 4.7-2.6q1.2 0.1 2.4 0.3 1.3 0.2 2.5 0.5 1.2 0.3 2.4 0.8 1.1 0.4 2.3 1c0.7 0.4-3.1 0.5-3.6 2.4z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m510.2 287.1c13.8 11-4.5 15.5-4.5 15.5l2.7 2.1-8.7-2.5 4.7-4 0.2 1.9c12.6-4.6 1.2-12.2 1.2-12.2z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m504.6 287.1l-1.3-0.9 4.2-1 1.7 1.2-4.6 0.7z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m464.4 275.8v1.3h-5.3v-1.1l2.7-2.5q0.1-0.1 0.2-0.2 0.1-0.1 0.1-0.2 0.1-0.1 0.2-0.2 0-0.1 0.1-0.2 0 0 0.1-0.1 0-0.1 0-0.1 0-0.1 0-0.2 0.1-0.1 0.1-0.1 0-0.1-0.1-0.2 0-0.1 0-0.2 0-0.1-0.1-0.2-0.1 0-0.1-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.2-0.1-0.1 0-0.3 0-0.1 0-0.2 0-0.1 0-0.2 0-0.1 0-0.2 0-0.1 0-0.2 0.1-0.1 0-0.2 0-0.1 0.1-0.2 0.2-0.1 0-0.2 0.1 0 0.1-0.1 0.1-0.1 0.1-0.1 0.2l-1.2-0.8q0.1-0.1 0.2-0.3 0.1-0.1 0.3-0.2 0.1-0.2 0.3-0.3 0.1-0.1 0.3-0.2 0.2 0 0.4-0.1 0.2-0.1 0.4-0.1 0.2-0.1 0.4-0.1 0.2 0 0.4 0 0.2 0 0.4 0 0.1 0 0.3 0.1 0.2 0 0.4 0 0.1 0.1 0.3 0.2 0.1 0 0.3 0.1 0.1 0.1 0.2 0.2 0.1 0.1 0.2 0.2 0.1 0.1 0.2 0.2 0.1 0.1 0.2 0.2 0 0.2 0.1 0.3 0 0.2 0 0.3 0 0.1 0 0.3 0 0.1 0 0.3 0 0.1 0 0.2 0 0.2-0.1 0.3 0 0.2-0.1 0.3-0.1 0.1-0.2 0.3-0.1 0.2-0.2 0.3-0.1 0.1-0.3 0.3-0.1 0.1-0.2 0.2l-1.6 1.6z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m546.5 264.4h87.3v73.6h-87.3z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m546.5 264.4h87.3v73.6h-87.3z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m550.2 267.5h79.9v45.2h-79.9z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m550.2 267.5h79.9v45.2h-79.9z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m550.2 267.5h11.9v12h-11.9z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m609.1 319.3q-0.3-0.2-0.3-0.6 0-0.4 0.3-0.6 0.2-0.3 0.6-0.3h12.8q0.3 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.3 0.3-0.6 0.3h-12.8q-0.4 0-0.6-0.3z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m581.5 319.3q-0.3-0.2-0.3-0.6 0-0.4 0.3-0.6 0.2-0.3 0.6-0.3h22.8q0.4 0 0.7 0.3 0.2 0.2 0.2 0.6 0 0.4-0.2 0.6-0.3 0.3-0.7 0.3h-22.8q-0.4 0-0.6-0.3z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m557.3 319.3q-0.3-0.2-0.3-0.6 0-0.4 0.3-0.6 0.2-0.3 0.6-0.3h18.8q0.4 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-18.8q-0.4 0-0.6-0.3z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m601.6 325.7q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h13.4q0.3 0 0.6 0.2 0.3 0.3 0.3 0.7 0 0.3-0.3 0.6-0.3 0.2-0.6 0.2h-13.4q-0.4 0-0.6-0.2z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m577 325.7q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h19q0.4 0 0.6 0.2 0.3 0.3 0.3 0.7 0 0.3-0.3 0.6-0.2 0.2-0.6 0.2h-19q-0.4 0-0.6-0.2z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m564.2 325.7q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h8q0.4 0 0.6 0.2 0.3 0.3 0.3 0.7 0 0.3-0.3 0.6-0.2 0.2-0.6 0.2h-8q-0.4 0-0.6-0.2z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m607.6 332q-0.3-0.2-0.3-0.6 0-0.3 0.3-0.6 0.2-0.3 0.6-0.3h10.3q0.4 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-10.3q-0.4 0-0.6-0.3z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m585.6 332q-0.2-0.2-0.2-0.6 0-0.3 0.2-0.6 0.3-0.3 0.6-0.3h17.1q0.4 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-17.1q-0.3 0-0.6-0.3z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m561.2 332q-0.3-0.2-0.3-0.6 0-0.3 0.3-0.6 0.2-0.3 0.6-0.3h18.7q0.3 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.3 0.3-0.6 0.3h-18.7q-0.4 0-0.6-0.3z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m600.9 262.5c0.9 0.8 1.5 2.1 1.5 3.4 0 1.3-0.6 2.5-1.5 3.4-0.9 0.9-2.2 1.3-3.5 1.3h-2.9c-1.3 0-2.6-0.4-3.5-1.3-1-0.9-1.5-2.1-1.5-3.4 0-1.3 0.5-2.6 1.5-3.4 0.9-0.9 2.2-1.4 3.5-1.3h2.9c1.3-0.1 2.6 0.4 3.5 1.3z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m602.1 265.9c0 1.9-1.2 3.6-2.9 4.3-1.8 0.8-3.8 0.4-5.1-1-1.4-1.3-1.8-3.4-1.1-5.1 0.8-1.8 2.5-2.9 4.4-2.9q0.9 0 1.8 0.3 0.9 0.4 1.5 1.1 0.7 0.6 1 1.5 0.4 0.8 0.4 1.8z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s19",
    d: "m597 286.2q0 0.1 0 0.2 0 0.1-0.1 0.2 0 0.2-0.1 0.3-0.4 0.2-0.8 0.4-0.5 0.3-1 0.4-0.4 0.2-0.9 0.3-0.5 0.2-1 0.3l-0.4 0.2-0.3 2.2c0 0 0.4 1.8 0.4 2.6 0.1 2-0.4 7.2-0.4 7.4q0.1 0.2 0.2 0.5 0.1 0.3 0.2 0.5 0.1 0.3 0.2 0.6 0 0.2 0.1 0.5 0.1 1.1 0.2 2.3 0 1.1 0.1 2.2 0 1.1 0 2.3 0 1.1-0.1 2.2l0.2 1h-3.6q0 0 0-0.1 0.1 0 0.1-0.1 0 0 0.1 0 0-0.1 0.1-0.1l1.7-0.7-2.6-18.6-1.9 7.8q0 0.3 0 0.5 0 0.3 0.1 0.5 0 0.2 0 0.5 0 0.2 0 0.5-0.2 1.1-0.5 2.3-0.2 1.1-0.5 2.2-0.2 1.2-0.5 2.3-0.3 1.1-0.6 2.2v0.8h-3.5q0-0.1 0-0.1 0-0.1 0-0.1 0.1-0.1 0.1-0.1 0 0 0.1 0l1.7-0.7 2.8-20.8v-2.2l-0.8-0.3q-0.3-0.2-0.6-0.4-0.3-0.2-0.5-0.4-0.3-0.2-0.5-0.4-0.3-0.3-0.5-0.5 0-0.1-0.1-0.2 0-0.2 0-0.3 0-0.1-0.1-0.2 0-0.1 0.1-0.3 0.2-0.6 0.6-1.2 0.3-0.6 0.7-1.2 0.3-0.6 0.8-1.2 0.4-0.5 0.8-1l2.6-0.2 0.3-0.8h-0.9l-0.6-0.8 0.4-2.5q-0.2-0.1-0.3-0.3-0.1-0.1-0.1-0.3 0-0.2 0-0.4 0.1-0.2 0.2-0.3c0.6-0.8 0.7 0.3 1.5 0.5 0.7 0.2 2.4 0.9 2 1.6q-0.1 0.2-0.3 0.5-0.1 0.3-0.1 0.6-0.1 0.2-0.2 0.5-0.1 0.3-0.1 0.6l0.1 1.1 2.6-0.2c0 0 3.1 3.5 3.4 5.1q0.1 0.1 0 0.3zm-10.5 1.3v-3.5q-0.2 0.2-0.4 0.4-0.2 0.3-0.3 0.5-0.2 0.2-0.3 0.5-0.1 0.2-0.3 0.5c0 0.4 0.8 1.7 0.8 1.7zm6.7-4l-0.4 4h0.2c0 0 1.9-0.9 2-1.6 0.1-0.6-1.2-1.9-1.8-2.4z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m575.6 296.1l1.6 3.2-11.2 5.8 1.4 1.5h-6.4l3.7-5.6 0.2 2.3 10.7-7.2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m576.2 295.6l1.2-0.8 1.8 3.4-1.4 0.7-1.6-3.3z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m574.5 284.5l-0.4 3.5-12.6-1.3 0.3 2.1-5.3-3.5 6.2-2.7-1.1 2 12.9-0.1z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m575.3 284.5h1.4l-0.4 3.7-1.5-0.1 0.5-3.6z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m603.4 284.5l12.9 0.1-1.1-2 6.3 2.7-5.4 3.5 0.3-2.1-12.5 1.3-0.5-3.5z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m602.7 284.5l0.4 3.6-1.5 0.1-0.4-3.7h1.5z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m603.4 296.1l10.6 7.2 0.2-2.3 3.8 5.6h-6.4l1.4-1.5-11.2-5.8 1.6-3.2z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m602.7 295.6l-1.6 3.3-1.3-0.7 1.8-3.4 1.1 0.8z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m558.5 273.5q0.1 0.1 0.2 0.3 0.1 0.1 0.2 0.3 0 0.2 0.1 0.4 0 0.1 0 0.3 0 0.2 0 0.3-0.1 0.2-0.1 0.3 0 0.2-0.1 0.3-0.1 0.1-0.1 0.3-0.1 0.1-0.2 0.2-0.2 0.1-0.3 0.2-0.1 0.2-0.2 0.2-0.2 0.1-0.3 0.2-0.2 0.1-0.4 0.1-0.2 0.1-0.4 0.1-0.2 0.1-0.4 0.1-0.2 0-0.4 0-0.2 0-0.4 0-0.2 0-0.4 0-0.2-0.1-0.4-0.1-0.1 0-0.3-0.1-0.2 0-0.3-0.1-0.2-0.1-0.4-0.1-0.1-0.1-0.3-0.2-0.1-0.1-0.2-0.2l0.6-1.2q0.1 0.1 0.2 0.1 0.1 0.1 0.2 0.2 0.2 0 0.3 0.1 0.1 0 0.2 0.1 0.2 0 0.3 0 0.1 0.1 0.3 0.1 0.1 0 0.2 0 0.2 0 0.3 0 0.1 0 0.3 0 0.1 0 0.2 0 0.1 0 0.3-0.1 0.1 0 0.2-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.2-0.2 0-0.1 0-0.2 0-0.1 0-0.2 0-0.9-1.3-0.9h-0.8v-1l1.5-1.6h-3.1v-1.4h5v1.1l-1.6 1.8q0.2 0.1 0.4 0.1 0.2 0 0.4 0.1 0.2 0.1 0.4 0.2 0.1 0.1 0.3 0.3z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m403.9 351.6h87.4v73.6h-87.4z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m403.9 351.6h87.4v73.6h-87.4z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m407.6 354.7h80v45.2h-80z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m407.6 354.7h80v45.2h-80z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m407.6 354.7h12v12h-12z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m466.6 406.5q-0.3-0.2-0.3-0.6 0-0.4 0.3-0.6 0.2-0.3 0.6-0.3h12.8q0.4 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-12.8q-0.4 0-0.6-0.3z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m438.9 406.5q-0.2-0.2-0.2-0.6 0-0.4 0.2-0.6 0.3-0.3 0.7-0.3h22.8q0.4 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-22.8q-0.4 0-0.7-0.3z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m414.7 406.5q-0.2-0.2-0.2-0.6 0-0.4 0.2-0.6 0.3-0.3 0.6-0.3h18.9q0.4 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-18.9q-0.3 0-0.6-0.3z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m459 412.9q-0.2-0.3-0.2-0.6 0-0.4 0.2-0.7 0.3-0.2 0.6-0.2h13.4q0.4 0 0.7 0.2 0.2 0.3 0.2 0.7 0 0.3-0.2 0.6-0.3 0.2-0.7 0.2h-13.4q-0.3 0-0.6-0.2z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m434.4 412.9q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h19q0.4 0 0.6 0.2 0.3 0.3 0.3 0.7 0 0.3-0.3 0.6-0.2 0.2-0.6 0.2h-19q-0.4 0-0.6-0.2z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m421.6 412.9q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h7.9q0.4 0 0.6 0.2 0.3 0.3 0.3 0.7 0 0.3-0.3 0.6-0.2 0.2-0.6 0.2h-7.9q-0.4 0-0.6-0.2z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m465 419.2q-0.3-0.2-0.3-0.6 0-0.3 0.3-0.6 0.2-0.3 0.6-0.3h10.3q0.4 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-10.3q-0.4 0-0.6-0.3z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m443.1 419.2q-0.3-0.2-0.3-0.6 0-0.3 0.3-0.6 0.2-0.3 0.6-0.3h17.1q0.4 0 0.6 0.3 0.3 0.3 0.3 0.6 0 0.4-0.3 0.6-0.2 0.3-0.6 0.3h-17.1q-0.4 0-0.6-0.3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m418.6 419.2q-0.3-0.2-0.3-0.6 0-0.3 0.3-0.6 0.2-0.3 0.6-0.3h18.7q0.3 0 0.6 0.3 0.2 0.3 0.3 0.6-0.1 0.4-0.3 0.6-0.3 0.3-0.6 0.3h-18.7q-0.4 0-0.6-0.3z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m458.2 349.8c0.9 0.8 1.4 2 1.4 3.3 0 1.2-0.5 2.4-1.4 3.3-0.9 0.9-2.1 1.4-3.4 1.4h-2.9c-1.2 0-2.4-0.5-3.3-1.4-0.9-0.9-1.4-2.1-1.4-3.3 0-1.3 0.5-2.5 1.4-3.3 0.9-0.9 2.1-1.4 3.3-1.4h2.9c1.3 0 2.5 0.5 3.4 1.4z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m459.6 353.1c0 1.9-1.2 3.6-3 4.3-1.7 0.8-3.7 0.4-5.1-1-1.3-1.3-1.7-3.4-1-5.1 0.7-1.8 2.4-2.9 4.3-2.9q1 0 1.8 0.3 0.9 0.4 1.6 1.1 0.6 0.6 1 1.5 0.4 0.8 0.4 1.8z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m442.9 368l1.2-2.6v-3l1.8-3.6h3.9c0 0 4.8-0.1 4.4 0.8-0.3 0.9-2.8 1.1-2.8 1.1v2.4l0.6 1.6h-0.8c0 0-0.6 3.9-3.2 2l-0.3 3z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m436 383.7l1-13.8c0 0-6.8-0.8-7.5 0.8-0.8 1.6 2.5 6 2.5 6l2.1-0.5 0.9 2.7-1.9 1.6-1.3-1.4c0 0-5-3-5.6-8-0.6-5.1 12.5-5.3 12.5-5.3l12.8 4.2c11.1 10.4 9.6-1.5 9.6-1.5l-2.8-0.9 1.3-2.4 3.4 1.6q0.4 1.1 0.7 2.2 0.3 1.2 0.3 2.4 0 1.1-0.3 2.3-0.3 1.2-0.7 2.2c-2.4 4.4-11.9-1.3-11.9-1.3l-5.2 12.7 6.4 12.7h-4.7l-7.8-8.2-5.6 8.2h-4.8l3.7-9.8 1.1-3.2z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m457.2 384.4c0 0 2.3 9.2-16.9 9.2-8 0-12.5-1.9-15.1-4.2l4.2-1.9c1.9 1.3 5.3 2.4 11.2 2.4 15.2 0 13.4-4.9 13.4-4.9l-3 1.2 2.4-4.6 7.1 2.1z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m427.6 385.7q0.1 0.2 0.2 0.3 0.1 0.2 0.2 0.3 0.2 0.2 0.3 0.3l-4.4 1.5q-0.2-0.3-0.4-0.6-0.2-0.3-0.4-0.6-0.1-0.2-0.3-0.5-0.1-0.4-0.2-0.7l4.8-0.3q0.1 0.2 0.2 0.3z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m422.1 384.5q0-0.2-0.1-0.3 0-0.2 0-0.4-0.1-0.2-0.1-0.3 0-0.2 0-0.4l4.9 1.2c0.1 0.1 0.2 0.3 0.2 0.5z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m416.9 362.8h-1.2v1.4h-1.6v-1.5h-3.8v-1.1l3.4-4.5h1.7l-3.1 4.3h1.9v-1.3h1.6v1.3h1.1z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m499 351.3h87.4v73.6h-87.4z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m499 351.3h87.4v73.6h-87.4z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m502.7 354.4h79.9v45.1h-79.9z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m502.7 354.4h79.9v45.1h-79.9z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m502.7 354.4h11.9v11.9h-11.9z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m561.6 406.2q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h12.8q0.3 0 0.6 0.2 0.3 0.3 0.3 0.7 0 0.3-0.3 0.6-0.3 0.2-0.6 0.2h-12.8q-0.4 0-0.6-0.2z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m534 406.2q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h22.9q0.3 0 0.6 0.2 0.2 0.3 0.2 0.7 0 0.3-0.2 0.6-0.3 0.2-0.6 0.2h-22.9q-0.4 0-0.6-0.2z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m509.8 406.2q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.7 0.2-0.2 0.6-0.2h18.8q0.4 0 0.7 0.2 0.2 0.3 0.2 0.7 0 0.3-0.2 0.6-0.3 0.2-0.7 0.2h-18.8q-0.4 0-0.6-0.2z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m554 412.5q-0.2-0.2-0.2-0.6 0-0.4 0.2-0.6 0.3-0.3 0.7-0.3h13.4q0.3 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.6-0.3 0.3-0.6 0.3h-13.4q-0.4 0-0.7-0.3z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m529.4 412.5q-0.2-0.2-0.2-0.6 0-0.4 0.2-0.6 0.3-0.3 0.6-0.3h19.1q0.3 0 0.6 0.3 0.2 0.2 0.2 0.6 0 0.4-0.2 0.6-0.3 0.3-0.6 0.3h-19.1q-0.3 0-0.6-0.3z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m516.6 412.5q-0.2-0.2-0.2-0.6 0-0.4 0.2-0.6 0.3-0.3 0.6-0.3h8q0.3 0 0.6 0.3 0.2 0.2 0.2 0.6 0 0.4-0.2 0.6-0.3 0.3-0.6 0.3h-8q-0.3 0-0.6-0.3z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m560.1 418.9q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.6 0.2-0.3 0.6-0.3h10.3q0.4 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.3-0.3 0.6-0.2 0.3-0.6 0.3h-10.3q-0.4 0-0.6-0.3z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m538.1 418.9q-0.2-0.3-0.2-0.6 0-0.4 0.2-0.6 0.3-0.3 0.7-0.3h17q0.4 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.3-0.3 0.6-0.2 0.3-0.6 0.3h-17q-0.4 0-0.7-0.3z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m513.7 418.9q-0.3-0.3-0.3-0.6 0-0.4 0.3-0.6 0.2-0.3 0.6-0.3h18.7q0.3 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.3-0.3 0.6-0.3 0.3-0.6 0.3h-18.7q-0.4 0-0.6-0.3z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m553.4 349.3c0.9 0.9 1.5 2.1 1.5 3.4 0 1.3-0.6 2.6-1.5 3.5-1 0.8-2.2 1.3-3.5 1.2h-2.9c-1.3 0.1-2.6-0.4-3.5-1.2-1-0.9-1.5-2.2-1.5-3.5 0-1.3 0.5-2.5 1.5-3.4 0.9-0.9 2.2-1.3 3.5-1.3h2.9c1.3 0 2.5 0.4 3.5 1.3z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m554.6 352.7c0 1.9-1.1 3.7-2.9 4.4-1.8 0.7-3.8 0.3-5.1-1-1.4-1.4-1.8-3.4-1.1-5.2 0.8-1.7 2.5-2.9 4.4-2.9q0.9 0 1.8 0.4 0.9 0.3 1.5 1 0.7 0.7 1 1.5 0.4 0.9 0.4 1.8z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m552.4 371l6.2 3.3-1.7 9.2-8.5 0.6-2-2-2.4 1.1-6.2-1.1-24.6 11.8-10.5 3.5v-14.9l34.5-6.9 15.2-4.6z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m509.6 373.4l0.8 3.2-2.8 0.4-0.8-3.4 2.8-0.2z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m528.7 370.6l5.5 1.7-3.9 2.8-0.5-1.3-18.1 2.6-0.8-3.1 18.3-1.2-0.5-1.5z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m518.3 393.8l1.7 2.9-2.6 1.2-1.7-3.1 2.6-1z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m536 385.9l5.7 0.1-3 3.8-0.8-1.1-16.7 7.5-1.6-2.8 17.2-6.2-0.8-1.3z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m548.4 399.5c0 0 3.8-14.4 15.8-13.6q2.3 0.2 4.6 0.3 2.3 0.2 4.6 0.5 2.3 0.3 4.6 0.6 2.4 0.4 4.6 0.8v11.4z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m575.8 380.3c0 0-0.7 4.7 0.7 6.8 0 0-8.8 3.2-9.9-1q0.5-0.4 0.9-0.8 0.4-0.5 0.7-1.1 0.3-0.5 0.5-1.1 0.2-0.6 0.2-1.2c0.5-3 6.9-1.6 6.9-1.6z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m567.9 386.2q-0.2 0-0.4 0-0.2 0-0.4-0.1-0.2 0-0.4-0.1 0.5-0.3 0.8-0.8 0.4-0.5 0.7-1 0.3-0.5 0.5-1.1 0.2-0.6 0.2-1.2c0.4-2.8 6-1.7 6.8-1.6-0.2 1.5-1.1 6-7.4 5.9q-0.2 0-0.4 0z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m578.4 371.3c-0.8 5.8-0.9 9.2-4.1 12-4.7 4.1-11.7 0.9-12.8-5-0.9-5.3 0.5-13.9 6.3-15.8q1.6-0.5 3.2-0.4 1.6 0.1 3 0.9 1.4 0.7 2.5 1.9 1 1.2 1.5 2.8 0.1 0.4 0.2 0.8 0.1 0.5 0.2 0.9 0 0.5 0 1 0 0.4 0 0.9z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m580.2 376.7q-0.3 0.4-0.6 0.8-0.4 0.4-0.8 0.7-0.4 0.3-0.9 0.5-0.4 0.3-0.9 0.4c-1.7 0.4-2.3-1.3-1.6-3 0.6-1.7 2.2-3.6 3.8-3.2 1.6 0.5 1.9 2.3 1 3.8z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m570.6 372.2c0 0.5-0.3 0.8-0.6 0.8-0.3 0-0.6-0.4-0.5-0.9 0-0.5 0.3-0.8 0.6-0.8 0.3 0 0.5 0.5 0.5 0.9z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m564.2 371.7c0 0.5-0.3 0.9-0.6 0.8-0.4 0-0.6-0.4-0.6-0.9 0.1-0.5 0.3-0.8 0.6-0.8 0.4 0 0.6 0.4 0.6 0.9z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m564.9 376.7q-0.3 0-0.6 0-0.3 0-0.6-0.1-0.3 0-0.5-0.2-0.3-0.1-0.5-0.3 0.4-0.5 0.7-0.9 0.4-0.5 0.7-1 0.3-0.5 0.6-1 0.3-0.5 0.5-1z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m570.2 366.9q0.1-0.1 0.1-0.1 0.1 0 0.1 0 0 0 0.1 0 0.2 0.1 0.5 0.1 0.3 0 0.5 0 0.3-0.1 0.5-0.2 0.3-0.1 0.5-0.3 0 0 0.1 0 0-0.1 0.1-0.1 0 0 0.1 0.1 0 0 0.1 0 0 0.1 0 0.1 0.1 0.1 0.1 0.1 0 0.1-0.1 0.1 0 0.1 0 0.1-0.3 0.2-0.6 0.4-0.3 0.1-0.6 0.2-0.3 0.1-0.7 0.1-0.3 0-0.6-0.1-0.1 0-0.1-0.1-0.1 0-0.1-0.1 0 0 0-0.1-0.1 0 0-0.1 0 0 0 0-0.1 0-0.1 0 0 0 0.1-0.1 0 0 0 0 0 0 0 0z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m562.6 367.4q0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0.3-0.3 0.6-0.4 0.3-0.2 0.6-0.2 0.3-0.1 0.7-0.1 0.3 0 0.6 0.1 0.1 0 0.1 0 0.1 0.1 0.1 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1-0.1 0.1 0 0.1 0 0.1-0.1 0-0.1 0-0.1 0-0.1 0-0.3 0-0.6 0-0.2 0-0.5 0-0.2 0.1-0.5 0.2-0.2 0.1-0.4 0.3 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m569.6 378.7q0.1 0 0.1 0 0 0.1 0 0.1 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0.1-0.1 0.1 0 0 0-0.1-0.1 0-0.1 0-0.5-0.3-1-0.5-0.6-0.2-1.2-0.3-0.6 0-1.1 0-0.6 0.1-1.2 0.3 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0.1 0 0.1 0 0.6-0.2 1.2-0.3 0.6-0.1 1.3 0 0.6 0 1.2 0.2 0.6 0.3 1.1 0.6z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s22",
    d: "m564.1 368.9q0.4 0.2 0.7 0.5 0.3 0.4 0.5 0.8 0.2 0.4 0.2 0.8c0 1-0.6 1.8-1.4 2.2-0.9 0.3-1.9 0.1-2.5-0.5-0.7-0.7-0.9-1.7-0.5-2.5 0.3-0.9 1.2-1.4 2.1-1.4q0.5 0 0.9 0.1zm-0.4 3.5q0.3-0.1 0.5-0.3 0.2-0.2 0.3-0.5 0.1-0.3 0.1-0.6c0-0.5-0.3-1.1-0.9-1.3-0.5-0.2-1.1-0.1-1.5 0.3-0.4 0.4-0.6 1.1-0.3 1.6 0.2 0.5 0.7 0.9 1.3 0.9q0.3 0 0.5-0.1z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s22",
    d: "m571.5 369.6q0.4 0.1 0.7 0.4 0.3 0.4 0.5 0.8 0.2 0.4 0.2 0.9c0 0.9-0.6 1.7-1.4 2.1-0.9 0.3-1.9 0.1-2.5-0.5-0.7-0.7-0.9-1.6-0.5-2.5 0.3-0.9 1.2-1.4 2.1-1.4q0.4 0 0.9 0.2zm-0.4 3.4q0.3-0.1 0.5-0.3 0.2-0.2 0.3-0.5 0.1-0.3 0.1-0.5c0-0.6-0.3-1.2-0.9-1.4-0.5-0.2-1.1-0.1-1.5 0.3-0.4 0.4-0.6 1.1-0.3 1.6 0.2 0.5 0.7 0.9 1.3 0.9q0.3 0 0.5-0.1z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m564.8 371.9q0.1-0.3 0.2-0.6 0-0.4-0.1-0.7 0-0.4-0.2-0.7c1.4 1.2 5 0.1 4.8 0.3q-0.3 0.2-0.5 0.5-0.2 0.3-0.3 0.7 0 0.4 0 0.7 0.1 0.4 0.3 0.7c-3.8-1.6-4.6-0.3-4.6-0.3q0.2-0.2 0.4-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.4
    }
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m582.6 397.1q-2.4 0.4-4.8 0.5-2.4 0.2-4.8 0.2-2.4 0-4.9-0.2-2.4-0.1-4.8-0.5-1.6-0.2-3.2-0.5-1.5-0.3-3.1-0.7-1.5-0.5-3-1-1.6-0.5-3-1.2 0.1-0.3 0.3-0.5 0.2-0.3 0.4-0.6 0.2-0.2 0.4-0.5 0.2-0.3 0.4-0.5 3.5 1.4 7.3 2.3 3.7 1 7.5 1.5 3.8 0.5 7.7 0.5 3.8 0 7.6-0.4z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m551.1 397.9q0.9 0.3 1.9 0.6 0.9 0.3 1.9 0.6 0.9 0.2 1.9 0.4h-8.4q0.1-0.3 0.2-0.5 0.1-0.3 0.2-0.6 0.1-0.3 0.2-0.6 0.1-0.3 0.2-0.5 0.9 0.3 1.9 0.6z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m582.6 391.2v1.8q-2.2 0.2-4.5 0.3-2.2 0.1-4.5 0.1-2.2 0-4.5-0.2-2.2-0.2-4.4-0.5c-6.9-1-9.2-2.5-10-3.5q0.2-0.2 0.4-0.4 0.3-0.1 0.5-0.3 0.2-0.2 0.5-0.4 0.2-0.1 0.4-0.3c2.1 1.1 10.7 4.8 26.1 3.4z"
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m510.7 360q0.2 0.2 0.3 0.3 0.2 0.2 0.3 0.4 0 0.2 0.1 0.5 0 0.2 0 0.4 0 0.2 0 0.3 0 0.2-0.1 0.3 0 0.2-0.1 0.3 0 0.2-0.1 0.3-0.1 0.1-0.2 0.3-0.1 0.1-0.2 0.2-0.2 0.1-0.3 0.2-0.1 0.1-0.3 0.1-0.2 0.1-0.4 0.2-0.2 0.1-0.4 0.1-0.2 0-0.4 0-0.2 0.1-0.4 0.1-0.2 0-0.4-0.1-0.1 0-0.3 0-0.2 0-0.4 0-0.2-0.1-0.4-0.1-0.1-0.1-0.3-0.1-0.1-0.1-0.3-0.2-0.2 0-0.3-0.1-0.2-0.1-0.3-0.2l0.6-1.2q0.3 0.1 0.5 0.2 0.3 0.1 0.5 0.2 0.3 0.1 0.5 0.1 0.3 0.1 0.6 0.1 0.1 0 0.2 0 0.1 0 0.3-0.1 0.1 0 0.2 0 0.1-0.1 0.2-0.2 0.1 0 0.2-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.2 0-0.1 0-0.2 0-0.1 0-0.2-0.1-0.1-0.1-0.2 0-0.1-0.1-0.2-0.1-0.1-0.2-0.1-0.1-0.1-0.3-0.1-0.1-0.1-0.3-0.1-0.2-0.1-0.3-0.1-0.2 0-0.4 0h-1.8l0.4-3.9h4.3v1.3h-2.9l-0.1 1.3h0.5q0.3 0 0.6 0 0.3 0.1 0.6 0.1 0.2 0.1 0.5 0.2 0.3 0.2 0.5 0.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m261.6 311.4c-17.6-0.6-11.4-7.9-11-11.5 0 0 1.3 0.6 1.8-1.6 2.1-8.6 0.2-20.7-1.7-28.2l21.1 14.8c-1.1 4.9-1.5 11 1.4 15.2q0.3 0.5 0.7 0.8 0.4 0.4 0.9 0.7 0.5 0.3 1.1 0.5 0.5 0.2 1.1 0.2l2.1 0.3c4.5 4.4-0.3 9.3-17.5 8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m259.3 276.2l12.5 8.7q-0.2 0.7-0.3 1.4-0.2 0.7-0.3 1.4-0.1 0.7-0.1 1.4-0.1 0.7-0.1 1.4c-4.6 0.9-11.2-3.4-12-7.8q-0.1-0.8-0.1-1.6 0-0.8 0-1.7 0-0.8 0.1-1.6 0.1-0.8 0.3-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m269.2 240c0 0 10.8-3.1 11.7 1q0.2 0.8 0 1.6-0.1 0.8-0.6 1.5-0.4 0.6-1.1 1-0.7 0.4-1.5 0.5v9.2l-11.8-11.8 0.7-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m247.9 261.4c-0.7-2.8-0.7-5.6 0.1-8.4 0.7-2.7 2.1-5.3 4.1-7.3 1.9-2.1 4.4-3.6 7.1-4.4 2.7-0.8 5.6-1 8.4-0.4 12.6 2.6 17.3 20.1 16.6 31.3-0.7 12.5-14.6 20.7-25.3 13.2-7.1-5.1-8.2-12.2-11-24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m273.7 258.2q0.6 1 1.3 2 0.7 1 1.5 1.9 0.8 1 1.6 1.8 0.8 0.9 1.7 1.7-0.4 0.5-0.9 0.8-0.5 0.4-1.1 0.6-0.6 0.2-1.2 0.3-0.6 0.1-1.3 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m266.9 257.7c0.7-0.1 1.3 0.6 1.4 1.5 0.1 0.9-0.2 1.6-0.8 1.8-0.6 0.1-1.2-0.6-1.4-1.5-0.1-0.9 0.2-1.6 0.8-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m277.3 256.3c0.6-0.1 1.2 0.5 1.4 1.5 0.1 0.9-0.2 1.6-0.8 1.8-0.7 0.1-1.3-0.6-1.4-1.5-0.2-0.9 0.2-1.6 0.8-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m262.4 256.6q0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0-0.1 0-0.1-0.1-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.2 0-0.1 0.1-0.2 0.3-0.6 0.7-1.1 0.4-0.5 0.9-0.8 0.6-0.4 1.2-0.7 0.6-0.2 1.2-0.3 0.1 0 0.2 0 0.1 0.1 0.2 0.1 0.1 0.1 0.1 0.2 0.1 0.1 0.1 0.2 0 0.1 0 0.2-0.1 0.1-0.1 0.2-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0.1-0.5 0-1 0.2-0.4 0.2-0.8 0.5-0.5 0.3-0.8 0.7-0.3 0.4-0.5 0.8-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.2 0.1 0 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m280.3 254q0 0-0.1 0-0.1 0-0.1-0.1-0.1 0-0.1 0-0.1-0.1-0.1-0.1-0.3-0.5-0.7-0.8-0.4-0.4-0.8-0.7-0.5-0.2-0.9-0.4-0.5-0.1-1.1-0.2-0.2 0-0.3-0.1-0.1-0.2-0.1-0.4 0-0.2 0.1-0.4 0.1-0.1 0.3-0.1 0.7 0 1.3 0.2 0.6 0.2 1.2 0.5 0.6 0.3 1 0.8 0.5 0.4 0.9 0.9 0 0.1 0 0.2 0.1 0.1 0.1 0.2-0.1 0.1-0.1 0.2-0.1 0.1-0.2 0.2 0 0 0 0-0.1 0.1-0.1 0.1 0 0-0.1 0 0 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m274.8 275.2c-3.8 0.4-5.6-1.1-6.7-3.1q1.3-0.1 2.5-0.2 1.3-0.1 2.5-0.1 1.3-0.1 2.6-0.1 1.2 0.1 2.5 0.1c0 0 0.4 3.1-3.4 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m272.8 273.8q0.6-0.1 1.1-0.1 0.6 0 1.1 0.1 0.6 0.1 1.1 0.2 0.5 0.2 1 0.4-0.2 0.2-0.5 0.3-0.3 0.2-0.6 0.3-0.3 0.1-0.6 0.1-0.3 0.1-0.6 0.1-0.5 0.1-1.1 0.1-0.5 0-1.1-0.1-0.5-0.1-1-0.2-0.5-0.2-1-0.4 0.2-0.2 0.5-0.3 0.3-0.2 0.5-0.3 0.3-0.1 0.6-0.1 0.3-0.1 0.6-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m277.9 271.8q-0.1 0.2-0.2 0.4-0.1 0.2-0.2 0.3-0.1 0.2-0.3 0.3-0.2 0.1-0.4 0.1-0.8 0.1-1.6 0.1-0.9 0-1.7 0-0.8 0-1.6 0-0.9 0-1.7-0.1-0.2 0-0.5 0-0.2-0.1-0.5-0.2-0.2-0.1-0.4-0.3-0.2-0.1-0.4-0.3 1.2-0.1 2.4-0.2 1.2-0.1 2.3-0.1 1.2-0.1 2.4-0.1 1.2 0.1 2.4 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m241.5 247.6l14.4-10.1 11.7 3.3c0 0-9.2-0.2-9.6 6.3-0.4 6.6-6.5 9.7-4.8 16.6 1.7 6.9-3.5 9.3-3.5 9.3l-6.7-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer copy",
    className: "s22",
    d: "m243.8 248.7c-4.2-0.7-8.1-4.9-4.1-9.8-0.8-4.1 5.5-8.8 10.6-7.7 3.2-3.6 7-2.8 12.4-1.4q1-0.7 2.1-1.1 1.2-0.4 2.4-0.5 1.2-0.1 2.4 0.2 1.2 0.3 2.3 0.9c2.5 1.7 5.2 0.3 5.4-0.7 5.2 2.4 7.1 6.7 5.5 11.4-1.5 4.7-5.1 4.1-8.4 4.1-1.7 2.3-6.9 2.1-10.9 0.3-1 2.4-4.9 4.9-9.9 3.2-1.1 2.1-9 3.1-9.8 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s19",
    d: "m283.9 259l-6.3 3.6-3.3-3.4-2.1 4.7-8 0.3-2.8-4.1-10 8.2-0.9-1.6 10.5-10 21-3.6zm-10.4-0.8l-0.9-2.2-10.2 1.6 2.6 5.3 6.4-0.4zm4.4 2.9l4.8-2.6-1.4-4.4-7 1.4 0.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s35",
    d: "m283.9 259l-6.3 3.6-3.3-3.4-2.1 4.7-8 0.3-2.8-4.1-10 8.2-0.9-1.6 10.5-10 21-3.6zm-10.4-0.8l-0.9-2.2-10.2 1.6 2.6 5.3 6.4-0.4zm4.4 2.9l4.8-2.6-1.4-4.4-7 1.4 0.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m243.1 271.9c-0.2-0.9-0.2-1.8 0-2.6 0.3-0.8 0.7-1.6 1.3-2.2 0.6-0.7 1.3-1.1 2.2-1.4 3.8-1.2 7.7 2.7 9.2 5.9 1.6 3.5 0.2 7.2-3.8 6.8q-1.1-0.1-2.2-0.5-1.1-0.3-2.1-0.9-1-0.5-1.8-1.2-0.9-0.8-1.6-1.7c-0.6-0.6-1-1.4-1.2-2.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Folder 1 copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "s36",
    d: "m270.6 282.7c0 0 3.9 6.5 8.1-0.7 0 0-4.3-2.3-8.1 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 2",
    className: "s37",
    d: "m281 271.2c0 0-7.3-5-16 0 0 0 7.3-2 16 0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m304.5 326.2q0.6-0.7 1.4-1.2 0.8-0.6 1.7-0.7 0.9-0.2 1.9 0 0.9 0.2 1.7 0.7c2.8 2 6.8 4.2 10 4.2 5.3 0 26.8-20.4 30.3-23.7q0.1-0.2 0.2-0.3 0.1-0.1 0.2-0.2 0.1-0.2 0.2-0.3 0.1-0.1 0.2-0.3l5.9-10q0.4-0.8 1.1-1.3 0.6-0.6 1.4-0.8 0.8-0.3 1.7-0.3 0.8 0 1.6 0.3l2.1 0.8q0.9 0.4 1.6 1 0.7 0.7 1.1 1.6 0.3 0.9 0.4 1.8 0 1-0.4 1.9l-1.7 4.2q-0.2 0.3-0.3 0.6-0.2 0.3-0.4 0.6-0.2 0.2-0.4 0.5-0.3 0.2-0.5 0.4l-7.9 5.7q-0.2 0.1-0.3 0.2-0.1 0.1-0.3 0.2-0.1 0.2-0.2 0.3-0.1 0.1-0.2 0.3c-3.3 4.2-24.8 31.8-33 33-6 0.9-15.6-3.3-21.4-6.2q-0.9-0.4-1.6-1.2-0.6-0.9-0.9-1.9-0.3-1-0.1-2 0.2-1 0.8-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m290.5 305.9q2.2 1 4.4 2.2 2.1 1.2 4.2 2.6 2 1.4 4 2.9 1.9 1.5 3.7 3.1c6.3 6 8.4 5.9 8.4 5.9q-0.9 2.6-2.1 5.2-1.2 2.5-2.7 4.8-1.4 2.4-3.2 4.6-1.7 2.2-3.7 4.1c-1.3 1.3-27.8-7.1-13-35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m298.7 341.3q2.3-2.3 4.2-4.8 2-2.6 3.7-5.3 1.6-2.8 3-5.7 1.4-2.9 2.4-5.9l5.6 3.2q-1.1 2.9-2.4 5.6-1.4 2.7-3.1 5.3-1.6 2.6-3.6 4.9-1.9 2.4-4.1 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m298.7 341.3q2.3-2.3 4.2-4.8 2-2.6 3.7-5.3 1.6-2.8 3-5.7 1.4-2.9 2.4-5.9l5.6 3.2q-1.1 2.9-2.4 5.6-1.4 2.7-3.1 5.3-1.6 2.6-3.6 4.9-1.9 2.4-4.1 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m296 638.2l16.3-2.9 2.8 27.7-12.9 2.2-6.2-27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s19",
    d: "m317.2 660.3q0 0-0.1 0 0-0.1-0.1-0.1 0 0 0-0.1-0.1 0-0.1 0 0-0.1 0-0.1 0-0.1 0-0.2 0 0 0 0 0.1-0.1 0.1-0.1c0.2-0.2 4.6-4 7.1-3.9q0.2 0 0.3 0.1 0.2 0 0.4 0.1 0.1 0.1 0.3 0.2 0.1 0.1 0.2 0.2 0.2 0.1 0.3 0.3 0.1 0.2 0.1 0.4 0.1 0.2 0 0.4 0 0.2-0.1 0.4c-0.4 0.8-2.2 1.6-3.9 1.9q-0.6 0.1-1.1 0.2-0.6 0.1-1.1 0.1-0.6 0.1-1.1 0.1-0.6 0.1-1.2 0.1zm1-0.7c2.8-0.2 6.3-1 6.8-2 0.1-0.2 0.1-0.4-0.2-0.7q-0.1-0.1-0.2-0.2 0-0.1-0.1-0.1-0.1 0-0.2-0.1-0.1 0-0.3 0 0 0-0.1 0-0.1 0-0.2 0-0.1 0-0.2 0 0 0-0.1 0-0.7 0.3-1.4 0.6-0.7 0.3-1.3 0.7-0.7 0.4-1.3 0.9-0.6 0.4-1.2 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s19",
    d: "m317.1 660.3q-0.1 0-0.1-0.1-0.1 0-0.1 0 0 0 0-0.1 0 0-0.1-0.1c0-0.2-0.4-4.1 1.1-5.9q0.2-0.2 0.4-0.4 0.2-0.2 0.4-0.3 0.2-0.1 0.5-0.2 0.2-0.1 0.5-0.1c0.9-0.1 1.3 0.3 1.5 0.7 0.6 1.6-2.2 5.3-3.8 6.4q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0.1 0 0.1 0 0-0.1 0 0 0 0 0zm2.5-6.5q-0.2 0-0.3 0.1-0.2 0-0.3 0.1-0.1 0.1-0.3 0.2-0.1 0.1-0.2 0.2-0.3 0.6-0.5 1.2-0.2 0.6-0.3 1.2-0.2 0.6-0.2 1.2 0 0.6 0 1.2c1.6-1.4 3.3-4.2 3-5.2 0-0.1-0.1-0.3-0.7-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m316.3 658.5q0.4 0 0.9 0 0.5 0.1 0.9 0.2 0.4 0.2 0.8 0.4c5.2 3.1 7.1 6.3 18.7 5.5 2.5-0.3 2.8 6.6-3 7.7-9.6 1.9-7.8 0.4-16 2.1-7 1.4-11.9 2.7-17.5 4h-0.5q-0.4 0-0.8-0.2-0.4-0.2-0.6-0.5-0.3-0.3-0.5-0.7-0.1-0.4-0.1-0.8l0.2-13.2q0-0.2 0.1-0.4 0.1-0.2 0.2-0.4 0.2-0.1 0.3-0.2 0.2-0.2 0.4-0.2l15.6-3.2q0.4-0.1 0.9-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m295.1 410l20 240.9-16.8 2.5c0 0-21.5-81.9-19.3-108.4l-22.6-87.5c0 0-8.5-18.5-2.3-48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m295.1 410l20 240.9-16.8 2.5c0 0-21.5-81.9-19.3-108.4l-22.6-87.5c0 0-8.5-18.5-2.3-48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m252 436l2.5-3.1h9.1l7.6-8.8c0 0 0.3 37.9-5.3 69.9l-9.5-36.6c0 0-3.6-7.8-4.4-21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m297.5 655.8l-2.4-7.8 21.3-3 0.4 8-19.3 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m208.6 636.1l16.4 2.2-6.4 27.1-12.6-1.8 2.6-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s19",
    d: "m221.4 661.8q0 0-0.1 0 0-0.1 0-0.1-0.1-0.1-0.1-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0.1 0 0.1-0.1 0 0 0.1 0c0.2-0.2 5.5-2.6 7.9-1.8q0.1 0.1 0.3 0.2 0.1 0.1 0.3 0.2 0.1 0.1 0.2 0.3 0.1 0.1 0.2 0.2 0.1 0.2 0.1 0.4 0.1 0.2 0.1 0.4 0 0.2-0.1 0.4-0.1 0.2-0.2 0.3c-0.7 0.8-2.6 0.9-4.4 0.8q-0.5-0.1-1.1-0.1-0.5-0.1-1.1-0.2-0.5-0.1-1.1-0.2-0.5-0.2-1.1-0.3zm1.2-0.4c2.7 0.6 6.3 0.9 7.1 0 0.1-0.1 0.2-0.3 0-0.7q-0.1-0.1-0.1-0.2-0.1-0.1-0.2-0.2-0.1 0-0.2-0.1-0.1 0-0.2-0.1-0.1 0-0.1 0-0.1 0-0.2-0.1-0.1 0-0.2 0 0 0-0.1 0-0.8 0-1.5 0.1-0.7 0.2-1.5 0.3-0.7 0.2-1.4 0.5-0.7 0.2-1.4 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s19",
    d: "m221.3 661.8q-0.1 0-0.1-0.1 0 0 0 0-0.1-0.1-0.1-0.1 0-0.1 0-0.1c0-0.2 0.8-4.1 2.8-5.4q0.2-0.2 0.4-0.3 0.2-0.1 0.5-0.1 0.2-0.1 0.5-0.1 0.3 0 0.5 0c1 0.2 1.2 0.7 1.2 1.1 0.2 1.6-3.6 4.5-5.4 5.1h-0.1q0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0zm4.2-5.5q-0.1 0-0.3 0-0.2 0-0.3 0-0.2 0.1-0.3 0.1-0.2 0.1-0.3 0.2-0.4 0.4-0.8 0.9-0.4 0.5-0.7 1.1-0.3 0.5-0.5 1.1-0.2 0.6-0.3 1.2c1.9-0.9 4.4-3.2 4.4-4.2 0-0.1 0-0.3-0.7-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m221.1 659.8q0.4 0.1 0.9 0.2 0.4 0.2 0.8 0.5 0.4 0.3 0.7 0.6c4.1 4.5 5 8 16.4 10.4 2.5 0.6 0.8 7.2-5.1 6.7-9.9-0.9-7.6-1.8-16-2.5-7.1-0.6-12.2-0.7-17.9-1.1q-0.1 0-0.1 0-0.1 0-0.1-0.1-0.1 0-0.1 0-0.1 0-0.2 0-0.4-0.1-0.7-0.4-0.3-0.3-0.5-0.7-0.2-0.3-0.2-0.8-0.1-0.4 0.1-0.8l3.9-12.6q0.1-0.2 0.2-0.4 0.1-0.2 0.3-0.3 0.2-0.1 0.4-0.2 0.2 0 0.4 0l15.8 1.3q0.5 0.1 1 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m274.5 411.2c0 0-4.8 52.4-52.3 241.9l-15.3-2.2c0 0 5-95.2 14.2-110.4l4-85.6c0 0-4.3-20.3 5.1-48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m274.5 411.2c0 0-4.8 52.4-52.3 241.9l-15.3-2.2c0 0 5-95.2 14.2-110.4l4-85.6c0 0-4.3-20.3 5.1-48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m204.8 653.1v-8.1l21.3 3.2-2 7.8-19.3-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m227.6 410.3c0 0 0.2-51.6-4.4-101.6q-0.1-1 0.1-1.9 0.3-0.9 0.8-1.7 0.6-0.8 1.4-1.3 0.8-0.5 1.7-0.7c9.3-2.2 32.2-5.7 61.3 2.1q1.6 0.4 2.9 1.3 1.3 0.8 2.3 2.1 1 1.3 1.6 2.7 0.5 1.5 0.6 3.1c0.5 17.4 2.1 62.4 2.8 98.7 0 0-26.2 5-71.1-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m220.6 401.9c-2.2-2.8-1.6-8.3-1.6-8.3 0 0-13.3-15.8-13.9-30.9-0.7-15.2 11.4-43.1 11.4-43.1l18.7 9.5c0 0-13.7 22.4-15.8 31.3-2 8.9 7.3 28.4 7.3 28.4 5.4 1.4 7.5 1.9 9.3 3.7q0.4 0.5 0.8 1.1 0.4 0.6 0.7 1.3 0.4 0.6 0.6 1.2 0.3 0.7 0.5 1.4 0.5 1.3 0.5 2.7 0 1.3-0.5 2.6-0.6 1.3-1.5 2.3-1 1-2.3 1.6l-0.6 0.3q-0.6 0.2-1.2 0.3-0.5 0.2-1.1 0.3-0.6 0-1.2 0-0.6-0.1-1.2-0.2l-5.1-1.3c0 0-3-3.1-3.8-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m229.6 341.1l-19-11.7c0 0 6.2-34.7 25.2-24 16.1 8.9-6.2 35.7-6.2 35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m209 330.5l1.6-7.8 24.5 14.6-5.5 5.9-20.6-12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m209 330.5l1.6-7.8 24.5 14.6-5.5 5.9-20.6-12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m275.6 306.3c0 0 5.8 1.6 4.2 17.4-1.6 15.7 3.2 37.4 3.2 37.4 0 0-6.7-3.3-12.2 0.7-5.6 4-8.5-2.3-8.5-2.3 0 0 10.1-37.2 3.1-43.2-7-6 10.2-10 10.2-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m275.6 306.3c0 0 5.8 1.6 4.2 17.4-1.6 15.7 3.2 37.4 3.2 37.4 0 0-6.7-3.3-12.2 0.7-5.6 4-8.5-2.3-8.5-2.3 0 0 10.1-37.2 3.1-43.2-7-6 10.2-10 10.2-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m274.2 320.5c0 0 3.1 2.7 1.4 11.2-1.7 8.5 3.1 20.4-0.4 25.9-0.4 0.6-2.9 1-2.9 1q-0.3 0.2-0.6 0.1-0.4 0-0.7-0.2-0.2-0.2-0.4-0.6-0.1-0.3-0.1-0.6c0.4-5.7 1.5-21.2 2.7-26.5q0.4-1.2 0.6-2.5 0.3-1.3 0.4-2.6 0.1-1.3 0.1-2.6 0-1.3-0.1-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m256.8 314.6c-10.6-1.2-13.5-10.8-14.2-13.7q0-0.3 0-0.5 0-0.2 0.1-0.4 0.1-0.2 0.2-0.4 0.1-0.1 0.3-0.2 0.4-0.2 0.9-0.3 0.5-0.1 0.9-0.1 0.5 0 1 0.1 0.4 0.1 0.8 0.3 0.2-0.7 0.4-1.2 0.3-0.5 0.7-1 0.5-0.4 1-0.7 0.5-0.3 1.1-0.4 0.3-0.1 0.6-0.1 0.3 0 0.6 0.1 0.3 0 0.6 0.1 0.2 0.2 0.5 0.4 2.2 1.6 4.7 2.9 2.5 1.3 5.2 2 2.7 0.8 5.5 1.1 2.7 0.3 5.5 0c0 0-3.8 13.4-16.4 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m256.8 314.6c-10.6-1.2-13.5-10.8-14.2-13.7q0-0.3 0-0.5 0-0.2 0.1-0.4 0.1-0.2 0.2-0.4 0.1-0.1 0.3-0.2 0.4-0.2 0.9-0.3 0.5-0.1 0.9-0.1 0.5 0 1 0.1 0.4 0.1 0.8 0.3 0.2-0.7 0.4-1.2 0.3-0.5 0.7-1 0.5-0.4 1-0.7 0.5-0.3 1.1-0.4 0.3-0.1 0.6-0.1 0.3 0 0.6 0.1 0.3 0 0.6 0.1 0.2 0.2 0.5 0.4 2.2 1.6 4.7 2.9 2.5 1.3 5.2 2 2.7 0.8 5.5 1.1 2.7 0.3 5.5 0c0 0-3.8 13.4-16.4 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m253 304.3q-0.6-0.3-1.3-0.7-0.7-0.4-1.3-0.8-0.7-0.4-1.3-0.9-0.6-0.5-1.2-0.9c-0.4-0.4-0.5 5.1 5.1 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m281 301.1c9.4 0.2-10.7 19.9-15.4 22.6-4.6 2.6-7.5-3.5-7.5-3.5 0 0-18.7-12.2-11.2-11.4 7.5 0.8 22.2-5 28.7-8.7 4-2.3 5.4 1 5.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m281 301.1c9.4 0.2-10.7 19.9-15.4 22.6-4.6 2.6-7.5-3.5-7.5-3.5 0 0-18.7-12.2-11.2-11.4 7.5 0.8 22.2-5 28.7-8.7 4-2.3 5.4 1 5.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m278.6 303.1c0 0-3 8-16.4 13.9q-0.4 0.2-0.9 0.2-0.4 0.1-0.9 0-0.5-0.1-0.9-0.3-0.4-0.2-0.7-0.5l-1.9-1.8c0 0 8.4 0.4 21.7-11.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryboard);
export default __webpack_public_path__ + "static/media/storyboard.eb3c27ec33a6fbdfe5ab7cecc372fd24.svg";
export { ForwardRef as ReactComponent };